import styled from "styled-components";

const ARROW_SVG_CLASSNAME = "arrow-svg";

export const Root = styled("div")({
  display: "none",

  [`@media screen and (min-width: 48rem)`]: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    [`:not(.no-margin)`]: {
      margin: "calc(var(--dui-size-space-20x)) var(--dui-size-space-4x) 0",
    },
    width: 64,
  },
});

export const Arrow = styled("button")({
  appearance: "none",
  background: "var(--dui-colors-background-base)",
  border: 0,

  [`.${ARROW_SVG_CLASSNAME}`]: {
    transition: "transform 0.2s ease-in-out",
  },

  "&:hover": {
    cursor: "pointer",

    [`.${ARROW_SVG_CLASSNAME}:not(.no-rotate)`]: {
      transform: "rotate(180deg)",
    },
  },
});

export const Line = styled("div")({
  background: "var(--dui-components-navigation-stroke-secondary)",
  height: "calc(50% - 35px)",
  width: 1,
});
